<template>
  <div>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
    >
      <template slot="action1" slot-scope="{ row, index }">
        <Button
          type="primary"
          icon="md-person-add"
          size="small"
          @click="inventory(row, index)"
        ></Button>
      </template>
    </Table>

    <div style="display:flex;justify-content: flex-end;"></div>
    <div style="display: flex;justify-content: space-between;margin: 30px 0;">
      <!-- <Page :total="total" @on-change="pageChange"></Page> -->
      <div>
        <Button
          type="primary"
          style="margin-top:15px"
          @click="endMetting"
          v-if="endMeeting"
          >结束会议</Button
        >
        <Button type="primary" style="margin-top:15px" @click="exportFile"
          >导出</Button
        >
        <Button
          type="primary"
          style="margin-top:15px"
          @click="returnPage"
          v-if="showreturnbtn"
          >返回</Button
        >
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      showreturnbtn: false,
      loading: false,
      spinShow: false,
      data: [],
      meetingName: "",
      modalShow: false,
      endMeeting: false,

      modal: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 100
      },
      total: 0,
      id: ""
    };
  },
  computed: {
    columns() {
      return [
        {
          title: "NO",
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("PB_Incumbent") /* 任职者 */,
          key: "userName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("English_Name") /* 任职者 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_Position_Title_Chinese") /* 职位(中文） */,
          key: "positionCTitle",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_Position_Title_English") /* 职位(英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Successors_Select") /* 查看继任者 */,
          slot: "action1",
          align: "center",
          minWidth: 120
        }
      ];
    }
  },
  created() {},
  mounted() {},
  methods: {
    exportFile() {
      this.spinShow = true;
      this.axios({
        url: "downloadPPT/downloadSuccessorList",
        method: "post",
        data: {
          id: this.getQueryVariable("id"),
          meetingName: this.meetingName
        },
        responseType: "blob"
      }).then(res => {
        var A = this.$store.getters.pageData.axiosHeader[
          "content-disposition"
        ].split("filename=")[1];
        var FileSaver = require("file-saver");
        FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
        this.spinShow = false;
      });
    },
    endMetting() {
      this.$Modal.confirm({
        title: "请确认是否需要结束当前会议?",
        onOk: () => {
          this.loading = true;
          axios
            .post("/AchPeopleBoard/saveEndPBDataList", {
              id: this.getQueryVariable("id")
            })
            .then(res => {
              this.loading = false;
              if (res) {
                this.$Message.info(`会议已结束`);
                this.returnPage();
              }
            });
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    getData() {
      let obj = {
        id: this.id,
        ...this.pageInfo
      };
      this.loading = true;
      axios.post("/TalentInventory/selectParticipants", obj).then(res => {
        this.loading = false;
        if (res) {
          this.data = res.data;
          if (this.data.length > 0) {
            this.endMeeting =
              this.data[0].meetingType == "人才盘点" &&
              this.getQueryVariable("beEnd") != 1
                ? true
                : false;
          }
          this.total = parseInt(res.pageInfo.total);
        }
      });
    },
    teamInfo(row, index) {
      // window.open(window.location. origin + #/evalReport?id=${this.$route.query.id}&orgId=${this.highTechForm.orgId})
      // const href = this.$router.resolve({path:"/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",query: { pageLink: 'name1' ,plan:true,id:row.talentInventoryId,serialnumber:row.serialnumber}});
      const href =
        "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?pageLink=name1&plan=true&id=" +
        row.talentInventoryId +
        "&serialnumber=" +
        row.serialnumber +
        "&pagename=" +
        row.userName +
        "&indexId=" +
        row.id;
      window.open(href, "_blank");
      // this.$router.push({ path: '/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27',
      // query: { pageLink: 'name1' ,plan:true,id:row.talentInventoryId,serialnumber:row.serialnumber} })
    },
    inventory(row, index) {
      this.$router.push({
        path: "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27",
        query: {
          pageLink: "name2",
          plan: true,
          id: row.talentInventoryId,
          serialnumber: row.serialnumber,
          beTopLevel: row.beTopLevel
        }
      });
    },
    personPage() {
      const href = this.$router.resolve({
        path: "/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",
        query: { id: 1 }
      });
      window.open(
        "/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",
        "_blank"
      );
    },
    deleteItem() {},
    selectUser() {
      this.$refs.selectPeopleVue.modal = true;
    },
    returnPage() {
      this.$router.back();
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/SuccessionInventory.vue